import React from 'react';
import {noop} from 'lodash';

import ClientRole from '/component/partial/report/ClientRole';
import LastOrderedDate from '/component/partial/report/LastOrderedDate';
import OrdersListHeader from '/component/partial/report/OrdersListHeader';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {generateOnRecordPress} from './AllGen0OrdersReport.util';
import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface AllGen0OrdersContentProps {
  loadingData: {
    total?: number;
  };
  showRecordPopover: () => void;
  recordsShowPopover: () => void;
  recordsShowRecord: () => void;
  onOrderPress: () => void;
}

export const AllGen0OrdersContent = ({
  loadingData = {},
  showRecordPopover = noop,
  recordsShowPopover = noop,
  recordsShowRecord = noop,
  onOrderPress = noop,
}: AllGen0OrdersContentProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }

  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: OrdersListHeader,
        personRoleComponent: ClientRole,
        personInfoComponent: LastOrderedDate,
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
          onOrderPress,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
